import React, { useEffect, useState } from 'react';
import './BadgePopup.css';

import { Avatar, Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import { getResource } from '../../utils/Api';

/**
 * Popup affichant le badge sélectionné par l'utilisateur
 *
 * Modifié par Frédérick Bethermat - 2026-03-17
 */
export default function BadgePopup({ isOpen, handleClose, selectedBadge }) {
  const [title, setTitle] = useState('');
  const [image, setImage] = useState('');
  const [description, setDescription] = useState('');
  const [categoryColor, setCategoryColor] = useState('');
  const [categoryName, setCategoryName] = useState('');
  const [obtainedAt, setObtainedAt] = useState('');

  useEffect(() => {
    setTitle(selectedBadge ? selectedBadge.title : '');
    setImage(selectedBadge ? selectedBadge.imagePath : '');
    setDescription(selectedBadge ? selectedBadge.description : '');
    setCategoryColor(selectedBadge ? selectedBadge.category_color : '');
    setCategoryName(selectedBadge ? selectedBadge.category_name : '');

    if (selectedBadge?.obtained_at) {
      const date = new Date(selectedBadge.obtained_at);
      const formatted = date.toLocaleDateString('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      });
      setObtainedAt(formatted);
    } else {
      setObtainedAt('');
    }
  }, [selectedBadge]);

  if (!isOpen) return null;

  return (
    <div className="popup-overlay" onClick={handleClose}>
      <div className="popup-container" onClick={(e) => e.stopPropagation()}>
        <button className="popup-close" onClick={handleClose}>
          ✕
        </button>

        <h2 className="popup-title">{title}</h2>

        <span
          className="popup-category"
          style={{ boxShadow: `0 0 12px 8px ${categoryColor}` }}
        >
          Catégorie: {categoryName || 'Non catégorisé'}
        </span>

        <div className="popup-content">
          <Avatar
            alt={title}
            src={image || getResource('badge.png')}
            className="avatar"
            sx={{ boxShadow: `0 0 8px 12px ${categoryColor}` }}
          />

          <Divider sx={{ width: '80%', borderColor: 'rgba(0,0,0,0.12)' }} />

          <Typography className="description">{description}</Typography>

          {obtainedAt && (
            <Typography className="obtained-at">
              Obtenu le {obtainedAt}
            </Typography>
          )}
        </div>
      </div>
    </div>
  );
}
